import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, RequireAuth, STAFF } from "./lib/auth";
import SiteLayout from "./components/SiteLayout";
import CmsPage from "./pages/public/CmsPage";
import ReviewPage from "./pages/public/ReviewPage";
import TravelerReviews from "./pages/staff/TravelerReviews";
import { EditProvider } from "./lib/cms";
import ItineraryPage from "./pages/public/ItineraryPage";
import TourPage from "./pages/public/TourPage";
import Quote from "./pages/public/Quote";
import Cruises from "./pages/public/Cruises";
import VoyagesOfPaul from "./pages/public/VoyagesOfPaul";
import FaithHeritage from "./pages/public/FaithHeritage";
import AuthPage, { ResetPassword } from "./pages/public/AuthPage";
import Register from "./pages/booking/Register";
import JourneyBuilder from "./pages/journey/JourneyBuilder";
import SharedJourney from "./pages/journey/SharedJourney";
import ProposalPage from "./pages/journey/ProposalPage";
import JourneyCatalog from "./pages/staff/JourneyCatalog";
import { JourneyRequests, JourneyRequest } from "./pages/staff/JourneyRequests";
import PaymentResult from "./pages/booking/PaymentResult";
import Portal from "./pages/portal/Portal";
import PortalBooking from "./pages/portal/PortalBooking";
import StaffLayout from "./pages/staff/StaffLayout";
import Dashboard from "./pages/staff/Dashboard";
import Tours from "./pages/staff/Tours";
import TourWorkspace from "./pages/staff/TourWorkspace";
import TravelerRecord from "./pages/staff/TravelerRecord";
import Tasks from "./pages/staff/Tasks";
import { Leads, Suppliers } from "./pages/staff/LeadsSuppliers";
import CruiseDeals from "./pages/staff/CruiseDeals";
import TermsTemplates from "./pages/staff/TermsTemplates";
import EmailSettings from "./pages/staff/EmailSettings";
import SignPage from "./pages/public/SignPage";
import StaffReservation from "./pages/staff/StaffReservation";
import Reports from "./pages/staff/Reports";
import Catalogue from "./pages/staff/Catalogue";
import Settings from "./pages/staff/Settings";
import { Reviews, Payments } from "./pages/staff/Reviews";
import { ScrollToTop } from "./components/ScrollToTop";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <EditProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<CmsPage slug="home" />} />
            <Route path="/about" element={<CmsPage slug="about" />} />
            <Route path="/faq" element={<CmsPage slug="faq" />} />
            <Route path="/contact" element={<CmsPage slug="contact" />} />
            <Route path="/group-tours" element={<CmsPage slug="group-tours" />} />
            <Route path="/custom-vacations" element={<CmsPage slug="custom-vacations" />} />
            <Route path="/cruises" element={<Cruises />} />
            <Route path="/cruises/voyages-of-paul" element={<VoyagesOfPaul />} />
            <Route path="/biblical-heritage-tours" element={<FaithHeritage />} />
            <Route path="/destinations" element={<CmsPage slug="destinations" />} />
            <Route path="/p/:slug" element={<CmsPage />} />
            <Route path="/itineraries/:slug" element={<ItineraryPage />} />
            <Route path="/tours/:code" element={<TourPage />} />
            <Route path="/review/:token" element={<ReviewPage />} />
            <Route path="/portal/sign/:rid" element={<RequireAuth><SignPage account /></RequireAuth>} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/holy-land/design-your-journey" element={<JourneyBuilder />} />
            <Route path="/holy-land/shared-journey/:token" element={<SharedJourney />} />
            <Route path="/holy-land/proposal/:token" element={<ProposalPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register/:code" element={<RequireAuth><Register /></RequireAuth>} />
            <Route path="/payment/success" element={<RequireAuth><PaymentResult /></RequireAuth>} />
            <Route path="/portal" element={<RequireAuth><Portal /></RequireAuth>} />
            <Route path="/portal/bookings/:id" element={<RequireAuth><PortalBooking /></RequireAuth>} />
          </Route>
          <Route path="/staff" element={<RequireAuth roles={STAFF}><StaffLayout /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="tours" element={<Tours />} />
            <Route path="tours/:id" element={<TourWorkspace />} />
            <Route path="tours/:id/reserve" element={<StaffReservation />} />
            <Route path="travelers/:id" element={<TravelerRecord />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="leads" element={<Leads />} />
            <Route path="cruise-deals" element={<CruiseDeals />} />
            <Route path="terms-templates" element={<TermsTemplates />} />
            <Route path="email" element={<EmailSettings />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="reports" element={<Reports />} />
            <Route path="catalog" element={<Catalogue />} />
            <Route path="settings" element={<Settings />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="traveler-reviews" element={<TravelerReviews />} />
            <Route path="payments" element={<Payments />} />
            <Route path="journey-requests" element={<JourneyRequests />} />
            <Route path="journey-requests/:id" element={<JourneyRequest />} />
            <Route path="journey-catalog" element={<RequireAuth roles={["admin", "manager", "marketing"]}><JourneyCatalog /></RequireAuth>} />
          </Route>
          <Route path="/sign/*" element={<Navigate to="/portal" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </EditProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
